import { auth } from '../config/supabase';

// Authentication utilities

// Get the current authentication token
export const getAuthToken = async () => {
  try {
    // Get the current session from Supabase
    const { data: { session } } = await auth.getSession();
    
    if (session?.access_token) {
      console.log('🔑 Using Supabase access token');
      return session.access_token;
    }
    
    // Fallback for development/transition period
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      console.log('⚠️ Using fallback localStorage token - please update to Supabase auth');
      return adminToken;
    }
    
    console.log('❌ No authentication token available');
    return null;
  } catch (error) {
    console.error('❌ Error getting auth token:', error);
    return null;
  }
};

// Check if user is authenticated
export const isAuthenticated = async () => {
  try {
    const { data: { session } } = await auth.getSession();
    return session !== null;
  } catch (error) {
    console.error('❌ Error checking authentication:', error);
    return false;
  }
};

// Check if user is admin
export const isAdmin = async () => {
  try {
    return await auth.isAdmin();
  } catch (error) {
    console.error('❌ Error checking admin status:', error);
    return false;
  }
};

// Get current user
export const getCurrentUser = async () => {
  try {
    const { data: { user } } = await auth.getUser();
    return user;
  } catch (error) {
    console.error('❌ Error getting current user:', error);
    return null;
  }
};

// Log out the user
export const logout = async () => {
  try {
    // Clear localStorage tokens (legacy)
    localStorage.removeItem('admin_token');
    localStorage.removeItem('user_data');
    
    // Sign out from Supabase
    await auth.signOut();
    
    console.log('✅ Logout successful');
  } catch (error) {
    console.error('❌ Error during logout:', error);
  }
};

// Setup axios headers with current auth token
export const setupAuthHeaders = async (axiosInstance) => {
  try {
    const token = await getAuthToken();
    
    if (token) {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      console.log('🔑 Auth headers set for API requests');
      return true;
    } else {
      delete axiosInstance.defaults.headers.common['Authorization'];
      console.log('⚠️ No token available, cleared auth headers');
      return false;
    }
  } catch (error) {
    console.error('❌ Error setting up auth headers:', error);
    return false;
  }
};

// For development/testing only - should not be used in production
export const setDevelopmentToken = () => {
  console.warn('⚠️ setDevelopmentToken is deprecated - use Supabase authentication instead');
  localStorage.setItem('admin_token', 'admin_token');
}; 